// extracted by mini-css-extract-plugin
export default {"recommendedPrefilledHint":"Ay40QUSk7q4hW9OpLbYk"};